import { MapActorV2 } from './MapActorV2';
import { formatAnalyticsMessage, logAnalyticsToDevtools } from './MapWorkerAnalyticsFormatters';
import { ToMapWorkerMessageWithQueueTime } from './MapWorkerProtocol';

interface GlobalWorkerContext {
  onmessage: (typeof globalThis)['onmessage'];
  postMessage: (data: unknown) => void;
}
const globalWorkerContext = globalThis as unknown as GlobalWorkerContext;

let actor: MapActorV2 | null = null;

globalWorkerContext.onmessage = ({ data }: { data: ToMapWorkerMessageWithQueueTime }) => {
  try {
    if (!('type' in data)) throw new Error(`Worker received message with no type`);
    console.debug('MapActorV2 receiving', data);

    const startTime = performance.now();

    actor ??= new MapActorV2((m) => {
      globalWorkerContext.postMessage(m);
    });
    actor.onMessage(data);

    // Track analytics
    const endTime = performance.now();
    const analyticsMessage = formatAnalyticsMessage(
      { startTime, endTime, queueTime: data.queueTime },
      data,
      actor.getAnalyticsExtras()
    );
    logAnalyticsToDevtools(analyticsMessage);
    globalWorkerContext.postMessage(analyticsMessage);
  } catch (error) {
    console.error(`Error in worker`, error, data);
    throw error;
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {};
